/*
 * Dev related Redux states
 *
 */
import store from '../../store'

export const DEV_TOGGLE_LOCALE_LABEL = "DEV_TOGGLE_LOCALE_LABEL";

export default function (state = {}, action) {
	if (process.env.APP_ENV != "development") {
		return {};
	}
	switch (action.type) {
		case DEV_TOGGLE_LOCALE_LABEL:
			return {
				...state,
				showLocaleLabel: state.showLocaleLabel ? false : true,
			}
			break;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ducks/Dev/index.js